import { render, staticRenderFns } from "./EditTemplateSettingsPopup.vue?vue&type=template&id=05e499ee"
import script from "./EditTemplateSettingsPopup.vue?vue&type=script&lang=ts"
export * from "./EditTemplateSettingsPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports